import request from '@/utils/http';

// eslint-disable-next-line no-return-await
const login = async (code) => request({
  method: 'get',
  url: '/dingtalk-login',
  params: { code },
});

const authLogin = async (code) => request({
  method: 'get',
  url: '/auth-login',
  params: { code },
});

export default {
  login,
  authLogin
};
